import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/StoReport';


const StoReport = ({ t }) => (
  <Container>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

StoReport.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(StoReport);
